import { forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { DrawerHeader as ArcDrawerHeader, DrawerHeaderProps } from 'arc';
import { useApplicationType } from '../../common/hooks/use-application-type';
import { FR_HEADER_HEIGHT } from '~/fr-page-layout/constants';

export const DrawerHeader = forwardRef(function DrawerHeader(
    props: DrawerHeaderProps,
    ref?: React.Ref<HTMLElement>
) {
    const { isFirstResponder } = useApplicationType();

    return (
        <ArcDrawerHeader
            {...props}
            sx={{
                ...(isFirstResponder && {
                    minHeight: FR_HEADER_HEIGHT,
                    display: 'flex',
                    alignItems: 'center',
                }),
                ...props.sx,
            }}
            ref={ref}
        >
            {props.children}
        </ArcDrawerHeader>
    );
});
